const messages = {
  "ui.emailSubject.placeholder": "Subject",
} as const;

export default messages;
